import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useSeo } from "@/lib/seo";

export default function NotFoundPage() {
  useSeo({ title: "Not Found | EasyQuran.UK", description: "The page you are looking for was not found." });
  return (
    <div className="max-w-2xl mx-auto px-4 py-24 text-center" data-testid="not-found-page">
      <p className="font-arabic text-3xl text-primary" dir="rtl">إِنَّ مَعَ الْعُسْرِ يُسْرًا</p>
      <h1 className="mt-4 font-display text-4xl">Page not found</h1>
      <p className="mt-3 text-foreground/70">The page you were looking for could not be found.</p>
      <Button asChild className="mt-6 pill-btn bg-primary hover:bg-primary/90" data-testid="back-home-btn">
        <Link to="/">Return home</Link>
      </Button>
    </div>
  );
}
